import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ProgressBarComponent } from './progress-bar.component';

@NgModule({
    declarations: [ProgressBarComponent],
    imports: [CommonModule, TwcModule, TranslateModule],
    exports: [ProgressBarComponent],
})
export class ProgressBarModule {}
